<template>
    <div class="detail">
        <div class="header">
            <div class="title">详情</div>
            <div class="extra" @click="$emit('changeVisible')">
                <a-icon type="close" />
            </div>
        </div>

        <div class="well" v-if="renderDetail.code">

            <template v-if="renderDetail.pipeFrom && renderDetail.pipeTo">
                <template v-if="liquidData || flowData">
                    <FbxLoader url="/flow.fbx" type="check-well" :width="420" :height="300" :text="labels" />
                </template>
                <template v-else>
                    <FbxLoader url="/check-well.fbx" type="check-well" :width="420" :height="300" :text="labels" />
                </template>
            </template>
            <template v-else-if="!renderDetail.pipeFrom && renderDetail.pipeTo">
                <FbxLoader url="/pipe-one-side.fbx" type="check-well" :width="420" :height="300" :text="labels" />
            </template>
            <template v-else-if="renderDetail.pipeFrom && !renderDetail.pipeTo">
                <FbxLoader url="/pipe-one-side.fbx" type="check-well" :width="420" :height="300" :text="labels" />
            </template>
            <template v-else>
                <FbxLoader url="/check-well.fbx" type="check-well" :width="420" :height="300" :text="labels" />
            </template>

        </div>

        <a-tabs v-model="activeTab">
            <a-tab-pane key="1" tab="基本信息">
                <Info :render-detail="renderDetail" />
            </a-tab-pane>
            <template v-if="Array.isArray(renderDetail.boundDevices)">
                <a-tab-pane v-for="item in renderDetail.boundDevices" :key="item.id" :tab="item.name">
                    <div class="content">
                        <div class="item">
                            <div class="label">液位：</div>
                            <div class="value">
                                <template v-if="nowData.liquidLevel">
                                    {{
                                        nowData.liquidLevel +
                                        parseFloat(renderDetail.elevation - depth).toFixed(3)
                                    }}m
                                </template>
                                <template v-else> -- </template>
                            </div>
                        </div>

                        <div class="item">
                            <div class="label">上报时间：</div>
                            <div class="value">
                                {{ nowData.ts ? nowData.ts : "--" }}
                            </div>
                        </div>
                    </div>
                </a-tab-pane>
            </template>
        </a-tabs>
    </div>
</template>
  
<script>
import { mapState } from "vuex";
import { mapMutations } from "vuex";
import request from "@/api/request";
import moment from "moment";
import Info from './info.vue'
import FbxLoader from "../fbx-loader.vue";
export default {

    components: {
        Info,
        FbxLoader
    },

    props: {
        detail: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            renderDetail: {},
            labels: [],

            activeTab: "1",
            date: [moment().subtract(1, "days"), moment()],

            nowData: {},
        };
    },

    computed: {


        ...mapState("gis", ["selectedWell"]),

        liquidData() {
            const list = this.renderDetail.boundDevices ?? [];
            const obj = list.find((item) => item.type === "liquidLevel");
            return obj ? obj : null;
        },
        flowData() {
            const list = this.renderDetail.boundDevices ?? [];
            const obj = list.find((item) => item.type === "flowMeter");
            return obj ? obj : null;
        },
    },

    watch: {
        detail() {
            this.getDetail();
        },

        liquidData() {
            this.getNowData();
        },
    },

    mounted() {
        this.getDetail();
    },

    methods: {
        ...mapMutations("gis", [
            "setDetail",
            "setCategory",
            "setType",
            "setSelectedWell",
        ]),
        getDetail() {

            request({
                url: '/model-analysis/pipe/rain/well/query',
                method: 'post',
                data: {
                    ids: [this.detail.id],
                }
            }).then((res) => {
                console.log("well detail", res);
                if (Array.isArray(res) && res.length > 0) {
                    const item = res[0];
                    this.renderDetail = {
                        ...item,
                        pipeFrom:
                            item.pipesFrom && item.pipesFrom[0] ? item.pipesFrom[0] : null,
                        pipeTo: item.pipesTo && item.pipesTo[0] ? item.pipesTo[0] : null,
                    };

                    this.setDetail(this.renderDetail);
                    this.setCategory("rain");
                    this.setType("well");

                    this.setSelectedWell([...this.selectedWell, this.renderDetail]);
                    console.log("BSL-Y-109：：：", this.renderDetail)
                    if (this.renderDetail) {
                        const depth = this.renderDetail.depth ? this.renderDetail.depth : 0
                        const labels = [
                            {
                                text: `埋深：${depth}米`,
                                position: [0, 10, 25],
                            },
                            {
                                text: `地面标高：${parseFloat(this.renderDetail.elevation).toFixed(3)}米`,
                                position: [0, 0, -15],
                            },

                            {
                                text: `管内底标高：${parseFloat(this.renderDetail.elevation - depth).toFixed(3)}米`,
                                position: [0, -25, 0],
                            },

                        ]


                        // if (this.renderDetail.pipeFrom) {
                        //     labels.push({
                        //         text: `管内底标高：${this.renderDetail.pipeFrom.elevationTo.toFixed(3)}米`,
                        //         position: [0, -25, 30],
                        //     })
                        //
                        //     labels.push({
                        //         // 最左侧中间
                        //         text: `距离井底：${parseFloat(depth - this.renderDetail.pipeFrom.buringDepthTo).toFixed(3)}米`,
                        //         position: [0, -40, 30],
                        //     })
                        //     labels.push({
                        //         // 最左侧下面
                        //         text: `管顶高程：${parseFloat(
                        //             this.renderDetail.pipeFrom.elevationTo +
                        //             this.renderDetail.pipeFrom.diameter * 0.001
                        //         ).toFixed(3)}米`,
                        //         position: [0, 0, 35],
                        //     })
                        //
                        //
                        // }
                        //
                        // if (this.renderDetail.pipeTo) {
                        //     labels.push({
                        //         text: `管底高程：${this.renderDetail.pipeTo.elevationFrom.toFixed(3)}米`,
                        //         position: [0, -20, -15],
                        //     })
                        //     labels.push({
                        //         text: `距离井底：${this.renderDetail.pipeTo.buringDepthFrom.toFixed(3)}米`,
                        //         position: [0, -40, -15],
                        //     })
                        //     labels.push({
                        //         text: `管顶高程：${parseFloat(
                        //             this.renderDetail.pipeTo.elevationFrom +
                        //             this.renderDetail.pipeTo.diameter * 0.01
                        //         ).toFixed(3)}米`,
                        //         position: [0, 0, -15],
                        //     })
                        // }


                        this.labels = labels;


                    }


                }
            });
        },

        getNowData() {
            request({
                url: "/data-service/dev/realTime",
                method: "post",
                data: {
                    devType: "liquidLevel",
                    eids: [this.liquidData.sn],
                },
            }).then((res) => {
                this.nowData = res;

                if (res.liquidLevel) {
                    this.labels.push({
                        text: `距离井盖：${this.renderDetail.depth ? this.renderDetail.depth - res.liquidLevel : "-"}米`,
                        position: [0, -55, -10],
                    })
                }



            });
        },


    },
};
</script>
  
  
<style lang="less" scoped>
.detail {
    position: fixed;
    top: 11vh;
    right: calc(1vw + 140px);
    z-index: 99;
    background-color: var(--detail-bgcolor);
    width: 420px;
    bottom: 2vh;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    border: 1px solid #0b4948;
    overflow-y: auto;

    &>.header {
        background-color: var(--default-bgcolor);
        color: #fff;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1vw;
        line-height: 4vh;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }


}
</style>